import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Observer, Subject, Subscription} from 'rxjs';
import { IdCampiCtxMenu } from '../../common/configuration/id-campi-ctx-menu';
import { MenuActions } from '../../common/configuration/menu-actions';
import { ConfigurationUtilServiceDto } from '../../common/models/configuration-util-service-dto';
import { CtxBodyAbstract } from '../../common/models/ctx-body-abstract';
import { CtxBodyFascicolo } from '../../common/models/ctx-body-fascicolo';
import { CtxBodyPratica } from '../../common/models/ctx-body-pratica';
import { CtxMenuSezioni } from '../../common/models/ctx-menu-sezioni';
import { CtxMessage } from '../../common/models/ctx-message';
import { DescrittoreSezione } from '../../common/models/descrittore-sezione';
import { SearchResponse } from '../../common/models/dto/search-response';
import { EntityCached } from '../../common/models/entity-cached';
import { FascicoloFull } from '../../common/models/fascicolo/fascicolo-full';
import { PraticaFull } from '../../common/models/pratica/pratica-full';
import { FaccettaRequest } from '../../search/faccette/faccetta-request';
import { PropertiesSettings } from '../configuration/properties-settings';
import { ServicePathsSettings } from '../configuration/service-paths-settings';
import { CacheDescrittori } from '../models/cache-descrittori';
import { RefreshHeader } from '../models/refresh-header';
import { ConfigurationUtilService } from './configuration-util-service';
import { HelpersService } from './helpers.service';
import { OperationsService } from './operations.service';
import {de} from "date-fns/locale";
import { AppData } from 'src/app/data-store';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';

@Injectable()
export class ViewManagerService {

  private _ctxMenuSezioni: Subject<CtxMenuSezioni> = new Subject();
  public ctxMenuSezioni: Observable<CtxMenuSezioni> = this._ctxMenuSezioni.asObservable();

  private _ctxMenuFaccette: Subject<FaccettaRequest> = new Subject();
  public ctxMenuFaccette: Observable<FaccettaRequest> = this._ctxMenuFaccette.asObservable();

  private _ctxResultPratiche: Subject<SearchResponse> = new Subject();
  public ctxResultPratiche: Observable<SearchResponse> = this._ctxResultPratiche.asObservable();

  private _ctxHeader: Subject<boolean> = new Subject();
  public ctxHeader: Observable<boolean> = this._ctxHeader.asObservable();

  private _ctxBody: Subject<CtxBodyAbstract> = new Subject();
  public ctxBody: Observable<CtxBodyAbstract> = this._ctxBody.asObservable();


  public _refreshNotifiche: Subject<RefreshHeader> = new Subject<RefreshHeader>();
  public refreshNotifiche: Observable<RefreshHeader> = this._refreshNotifiche.asObservable();

  public _adempimentiInevasi: Subject<RefreshHeader> = new Subject<RefreshHeader>();
  public adempimentiInevasi: Observable<RefreshHeader> = this._adempimentiInevasi.asObservable();

  public _prossimiAdempimenti: Subject<RefreshHeader> = new Subject<RefreshHeader>();
  public prossimiAdempimenti: Observable<RefreshHeader> = this._prossimiAdempimenti.asObservable();

  public _refreshAttivitaCompletare: Subject<RefreshHeader> = new Subject<RefreshHeader>();
  public refreshAttivitaCompletare: Observable<RefreshHeader> = this._refreshAttivitaCompletare.asObservable();

  private errorObserver: Observer<String>;
  public errorObservable: Observable<String>;

  private descrittoriCached: CacheDescrittori;
  private entityCached: EntityCached;
  public errorMsg;

  private _descriptors: BehaviorSubject<DescrittoreSezione[]> = new BehaviorSubject<DescrittoreSezione[]>([]);
  public descriptors$: Observable<DescrittoreSezione[]> = this._descriptors.asObservable();

  private iconDocumentSubject = new BehaviorSubject<{ viewDocumentIcon: boolean }>({ viewDocumentIcon: false });
  public iconDocumentSubject$ = this.iconDocumentSubject.asObservable();

  private intestazioneSubject = new BehaviorSubject<void>(undefined);
  public intestazioneSubject$ = this.intestazioneSubject.asObservable();

  private operationsReadFascicoloSubscription: Subscription;

  private documentazioneSubject = new BehaviorSubject<DocumentoAllegato[]>([]);
  public documentazione$ = this.documentazioneSubject.asObservable();

  private ricercaAggregataSubject = new BehaviorSubject<boolean>(false);
  public ricercaAggregata$ = this.ricercaAggregataSubject.asObservable();

  private _showModal: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public get showModal(): Observable<boolean>{
    return this._showModal.asObservable();
  }

  constructor(private helpers: HelpersService,
    private operations: OperationsService,
    private configUtilService: ConfigurationUtilService
  ) {
    this.errorObservable = new Observable<String>(observer => {
      this.errorObserver = observer;
    });
  }

  /*ngOnInit() {
    this._ctxBody = new Subject();
    this.ctxBody = this._ctxBody.asObservable();
  }*/

  setShowModal(value?: boolean){
    let v = value;
    this._showModal.next(v);
  }

  dynamicInjectComponent(context: string) {
    let index = pdaConfiguration.findIndex(x => x.context === context && x.enabled === true);
    if(index > -1) {
      return pdaConfiguration[index];
    } else {
      return null
    }
  }

  storeErrorMsg(message) {
    this.errorMsg = message;
  }

  resetCacheDescrittori() {
    this.descrittoriCached = null;
  }

  getErrorMsg() {
    let result;
    if (this.errorMsg) {
       result = this.errorMsg;
    } else {
      result = "";
    }
    return result;
  }

  disegnaMenu(msg: CtxMessage) {
    // debugger;
    this.hideMenuFaccette();
        if (this.descrittoriCached) {
      if (this.descrittoriCached.azione === msg.azione) {
        if (MenuActions.VISUALIZZA_PRATICA === this.descrittoriCached.azione) {
          if (this.descrittoriCached.idTipoPratica === msg.idTipoPratica) {
            this.switchAzione(msg);
          } else {
            this.getDescrittoriSezione(msg);
          }
        } else if (MenuActions.VISUALIZZA_FASCICOLO === this.descrittoriCached.azione) {
          if (this.descrittoriCached.idTipoFascicolo === msg.idTipoFascicolo) {
            this.switchAzione(msg);
          } else {
            this.getDescrittoriSezione(msg);
          }
        } else if (MenuActions.CREA_PRATICA === this.descrittoriCached.azione) {
          if (this.descrittoriCached.idTipoPratica === msg.idTipoPratica) {
            this.switchAzione(msg);
          } else {
            this.getDescrittoriSezione(msg);
          }
        } else if (MenuActions.INSERISCI_FASCICOLO === this.descrittoriCached.azione) {
          if (this.descrittoriCached.idTipoFascicolo === msg.idTipoFascicolo) {
            this.switchAzione(msg);
          } else {
            this.getDescrittoriSezione(msg);
          }
        } else if (MenuActions.INSERISCI_FASCICOLO_E_VEDI_PRATICA === this.descrittoriCached.azione) {
            this.getDescrittoriSezione(msg);
            this.switchAzione(msg);
        } else if (MenuActions.CREA_FASCICOLO === this.descrittoriCached.azione) {
          this.getDescrittoriSezione(msg);
        }
      } else {
        this.getDescrittoriSezione(msg);
      }
    } else {
      this.getDescrittoriSezione(msg);
    }
  }


  applicaMenuFaccette(searchRespose: SearchResponse) {
    let faccettaRequest: FaccettaRequest = new FaccettaRequest();
    faccettaRequest.faccetteApplicabili = searchRespose ? searchRespose.faccetteApplicabili: null;
    faccettaRequest.searchRequest = searchRespose ? searchRespose.searchCriteria : null;
    faccettaRequest.includePratiche = searchRespose ? searchRespose.includePratiche : null;
    AppData.getInstance().temporaryFaccette = faccettaRequest;
    //faccetteApp.showFaccette = true;
    //faccetteApp.faccette = searchRespose.faccetteApplicabili;
    this._ctxMenuFaccette.next(faccettaRequest);
  }

  hideMenuFaccette() {
    this._ctxMenuFaccette.next(new FaccettaRequest());
  }

  svuotaMenu() {
    let ctxMenu: CtxMenuSezioni = new CtxMenuSezioni();
    ctxMenu.inserimento = false;
    ctxMenu.secondoStadioInserimento = false;
    ctxMenu.upperList = [];
    ctxMenu.lowerList = [];
    ctxMenu.showMenu = true;
    this._ctxMenuSezioni.next(ctxMenu);
    this.hideMenuFaccette();
  }

  hideMenu() {
    let ctxMenu: CtxMenuSezioni = new CtxMenuSezioni();
    ctxMenu.inserimento = false;
    ctxMenu.secondoStadioInserimento = false;
    ctxMenu.upperList = [];
    ctxMenu.lowerList = [];
    ctxMenu.showMenu = false;
    this._ctxMenuSezioni.next(ctxMenu);
    this.hideMenuFaccette();
  }

  hideNotifiche() {
    this._ctxHeader.next(false);
  }

  showHeader() {
    this._ctxHeader.next(true);
  }

  completeHeader() {
    this._ctxHeader.complete();
  }

  private getDescrittoriSezione(msg: CtxMessage) {
    if (msg.azione === MenuActions.VISUALIZZA_PRATICA) {
      this.helpers.getDescrittoriSezione(msg.azione, msg.idTipoPratica, null, null).subscribe(
        response => this.trasformaListaDescrittoriInMappa(msg, response)
      );
    } else if (msg.azione === MenuActions.VISUALIZZA_FASCICOLO) {
      //idEntita è l'id del fascicolo
      this.helpers.getDescrittoriSezione(msg.azione, msg.idTipoPratica, msg.idTipoFascicolo, msg.idEntita).subscribe(
        response => this.trasformaListaDescrittoriInMappa(msg, response)
      );
    } else if (msg.azione === MenuActions.CREA_PRATICA) {
      this.helpers.getDescrittoriSezione(msg.azione, msg.idTipoPratica, msg.idTipoFascicolo, null).subscribe(
        response => this.trasformaListaDescrittoriInMappa(msg, response)
      );
    } else if (msg.azione === MenuActions.INSERISCI_FASCICOLO) {
      this.helpers.getDescrittoriSezione(msg.azione, msg.idTipoPratica, msg.idTipoFascicolo, null).subscribe(
        response => this.trasformaListaDescrittoriInMappa(msg, response)
      );
    } else if (msg.azione === MenuActions.CREA_FASCICOLO) {
      this.helpers.getDescrittoriSezione(msg.azione, msg.idTipoPratica, msg.idTipoFascicolo, null).subscribe(
        response => this.trasformaListaDescrittoriInMappa(msg, response)
      );
    }
  }

  private trasformaListaDescrittoriInMappa(msg: CtxMessage, descrittori: DescrittoreSezione[]) {
    if (!descrittori) {
      descrittori = [];
    }

    let descrittoriMap: { [id: string]: DescrittoreSezione } = {};
    for (let descrittore of descrittori) {
      descrittoriMap[descrittore.entitySimpleName] = descrittore;
    }
    AppData.getInstance().descrittoriSezione = descrittoriMap;
    this.descrittoriCached = new CacheDescrittori(msg.idTipoPratica, msg.idTipoFascicolo, msg.azione, descrittoriMap);
    this.switchAzione(msg);
  }

  private switchAzione(msg: CtxMessage) {
    let ctxMenu: CtxMenuSezioni = new CtxMenuSezioni();
    ctxMenu.showMenu = true;

    switch (msg.azione) {
      case MenuActions.VISUALIZZA_PRATICA:
        this.switchTipoEntitaVisualizzaPratica(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        this._ctxMenuSezioni.next(ctxMenu);
        break;
      case MenuActions.VISUALIZZA_FASCICOLO:
        this.switchTipoEntitaVisualizzaFascicolo(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        this._ctxMenuSezioni.next(ctxMenu);
        break;
      case MenuActions.CREA_PRATICA:
        this.switchTipoEntitaCreaPratica(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        this._ctxMenuSezioni.next(ctxMenu);
        break;
      case MenuActions.CREA_FASCICOLO:
        this.switchTipoEntitaCreaFascicolo(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        this._ctxMenuSezioni.next(ctxMenu);
        break;
      case MenuActions.INSERISCI_FASCICOLO:
        this.switchTipoEntitaInserisciFascicolo(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        break;
      case MenuActions.INSERISCI_FASCICOLO_E_VEDI_PRATICA:
        this.switchTipoEntitaInserisciFascicolo(msg, ctxMenu, this.descrittoriCached.descrittoriMap);
        break;
    }
  }

  private switchTipoEntitaVisualizzaPratica(msg: CtxMessage, ctxMenu: CtxMenuSezioni, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    let descrittoriBody: DescrittoreSezione[] = [];
    let urlPratica: string = null;
    let cusd: ConfigurationUtilServiceDto = new ConfigurationUtilServiceDto(msg, ctxMenu, descrittoriBody, this.descrittoriCached, descrittoriMap, urlPratica);
    let cusdReturned = this.configUtilService.configuraCtxMenuVisualizzazionePratica(cusd);
    if (ServicePathsSettings.useCachedEntity && this.entityCached && cusdReturned.msg.idEntita === this.entityCached.idLastEntity && this.usableCache(cusdReturned.msg.idActiveButton)) {
      this.nextContextBodyPratica(cusdReturned.descrittoriBody, this.entityCached.praticaFull);
    } else {
      this.getPratica(cusdReturned.url, cusdReturned.descrittoriBody, cusdReturned.msg);
    }
  }

  private switchTipoEntitaVisualizzaFascicolo(msg: CtxMessage, ctxMenu: CtxMenuSezioni, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    let descrittoriBody: DescrittoreSezione[] = [];
    let urlFascicolo: string = null;
    let cusd: ConfigurationUtilServiceDto = new ConfigurationUtilServiceDto(msg, ctxMenu, descrittoriBody, this.descrittoriCached, descrittoriMap, urlFascicolo);
    let cusdReturned = this.configUtilService.configuraCtxMenuVisualizzazioneFascicolo(cusd);
    if (ServicePathsSettings.useCachedEntity && this.entityCached && cusdReturned.msg.idEntita === this.entityCached.idLastEntity && this.usableCache(cusdReturned.msg.idActiveButton)) {
      this.nextContextBodyFascicolo(cusdReturned.descrittoriBody, this.entityCached.fascicoloFull);
    } else {
      this.getFascicolo(cusdReturned.url, cusdReturned.descrittoriBody, cusdReturned.msg);
    }
  }

  private switchTipoEntitaCreaPratica(msg: CtxMessage, ctxMenu: CtxMenuSezioni, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    ctxMenu.inserimento = true;
    ctxMenu.secondoStadioInserimento = false;
    let descrittoriBody: DescrittoreSezione[] = [];
    let urlPratica: string = null;
    let cusd: ConfigurationUtilServiceDto = new ConfigurationUtilServiceDto(msg, ctxMenu, descrittoriBody, this.descrittoriCached, descrittoriMap, urlPratica);
    let cusdReturned = this.configUtilService.configuraCtxMenuCreazionePratica(cusd);
  }

  private switchTipoEntitaCreaFascicolo(msg: CtxMessage, ctxMenu: CtxMenuSezioni, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    ctxMenu.inserimento = true;
    ctxMenu.secondoStadioInserimento = false;
    let descrittoriBody: DescrittoreSezione[] = [];
    let urlFascicolo: string = null;
    let cusd: ConfigurationUtilServiceDto = new ConfigurationUtilServiceDto(msg, ctxMenu, descrittoriBody, this.descrittoriCached, descrittoriMap, urlFascicolo);
    let cusdReturned = this.configUtilService.configuraCtxMenuCreazioneFascicolo(cusd, msg.idEntita);
  }

  private switchTipoEntitaInserisciFascicolo(msg: CtxMessage, ctxMenu: CtxMenuSezioni, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    ctxMenu.inserimento = true;
    ctxMenu.secondoStadioInserimento = true;
    let descrittoriBody: DescrittoreSezione[] = [];
    let urlFascicolo: string = null;
    let cusd: ConfigurationUtilServiceDto = new ConfigurationUtilServiceDto(msg, ctxMenu, descrittoriBody, this.descrittoriCached, descrittoriMap, urlFascicolo);
    cusd._ctxBody = this._ctxBody;
    cusd._ctxMenuSezioni = this._ctxMenuSezioni;
    let cusdReturned = this.configUtilService.configuraCtxMenuInserimentoFascicolo(cusd, msg.idEntita);

  }

  private getPratica(urlPratica: string, descrittoriBody: DescrittoreSezione[], msg: CtxMessage) {
    this.operations.readPratica(urlPratica, msg.idEntita)
      .subscribe(praticaFull => this.cacheNuovaPratica(descrittoriBody, praticaFull.pratica));
  }

  private getFascicolo(urlFascicolo: string, descrittoriBody: DescrittoreSezione[], msg: CtxMessage) {
    // this.descrittoriTemp = descrittoriBody;
    this.operationsReadFascicoloSubscription = this.operations.readFascicolo(urlFascicolo, msg.idEntita)
      .subscribe(fascicoloFull => this.cacheNuovoFascicolo(descrittoriBody, fascicoloFull.fascicolo));
  }

  private nextContextBodyPratica(descrittori: DescrittoreSezione[], pratica: PraticaFull) {
    this._ctxBody.next(new CtxBodyPratica(descrittori, pratica));
  }

  private nextContextBodyFascicolo(descrittori: DescrittoreSezione[], fascicolo: FascicoloFull) {
    this._ctxBody.next(new CtxBodyFascicolo(descrittori, fascicolo));
  }

  private cacheNuovoFascicolo(descrittori: DescrittoreSezione[], fascicolo: FascicoloFull) {
    if (fascicolo) {
      this.entityCached = new EntityCached(fascicolo.id, null, fascicolo);
      this.nextContextBodyFascicolo(descrittori, fascicolo);
    } else {
      this.notifyMessage(PropertiesSettings.MSG_NO_FASCICOLO);
    }
  }

  private cacheNuovaPratica(descrittori: DescrittoreSezione[], pratica: PraticaFull) {
    if (pratica) {
      this.entityCached = new EntityCached(pratica.id, pratica, null);
      this.nextContextBodyPratica(descrittori, pratica);
    } else {
      this.notifyMessage(PropertiesSettings.MSG_NO_PRATICA);
    }
  }

  private usableCache(idActiveButton: string) {
    if (idActiveButton === IdCampiCtxMenu.DOCUMENTAZIONE_ALLEGATA_FASCICOLO || idActiveButton === IdCampiCtxMenu.DATI_GENERALI_FASCICOLO || idActiveButton === IdCampiCtxMenu.COPERTINA_FASCICOLO || idActiveButton === IdCampiCtxMenu.DATI_GENERALI_PRATICA) {
      return false;
    }
    return true;
  }

  private notifyMessage(message: string) {
    if (this.errorObserver) {
      this.errorObserver.next(message);
    } else {
      alert(message);
    }
  }

  initializeBody() {
    this._ctxBody = new Subject();
    this.ctxBody = this._ctxBody.asObservable();
  }

  completeBody() {
    this._ctxBody.complete();
    if (this.operationsReadFascicoloSubscription) {
      this.operationsReadFascicoloSubscription.unsubscribe();
    }
  }
  reloadRisultatiRicercaPratiche(searchResponse: SearchResponse) {

    this._ctxResultPratiche.next(searchResponse);

  }
  cacheDescriptors(descriptors: DescrittoreSezione[]) {
    console.log("[cacheDescriptors]", descriptors);
    this._descriptors.next(descriptors);
  }

  emitEvent(viewDocumentIcon: boolean) {
    this.iconDocumentSubject.next({ viewDocumentIcon });
  }
  updateIntestazione() {
    this.intestazioneSubject.next();
  }

  updateDocumentazione(documenti: DocumentoAllegato[]) {
    console.log('documenti', documenti)
    this.documentazioneSubject.next(documenti);
  }

  updateRicercaAggregata() {
    this.ricercaAggregataSubject.next(false);
  }

  setRicercaAggregata(value: boolean) {
    this.ricercaAggregataSubject.next(value); 
  }
}
